import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Form, Control } from 'react-redux-form';
import { Row, Col, OverlayTrigger, Popover } from 'react-bootstrap';
import Translation from "../../../../common/translation/translation.component";
import { TRANSLATIONS as translation } from '../../../../../utils/constant.utils';
import {
    ORFButton
    , ORFSearchSuggestions as SearchSuggestions
    , OR_RRF_Select as Select
    , OR_RRF_TextArea as TextArea
} from '../../../../common/forms/order-request-form.component';
import { createRequestActions } from "./../../../../../store/external/request-reducer/create-request.reducer";
import { requestLogActions } from "./../../../../../store/external/request-reducer/request-log.reducer";
import { wirelessChangePricePlanActions } from "./../../../../../store/external/request-reducer/order-request-reducer/wireless-request/wireless-change-price-plan.reducer";

class MobileChangePricePlanForm extends Component {
    constructor(props) {
        super(props);
    }

    componentWillUnmount() {
        const { resetWirelessChangePricePlanForm
            , resetWirelessChangePricePlanModel, resetRequestData } = this.props;

        resetWirelessChangePricePlanForm();
        resetWirelessChangePricePlanModel();
        resetRequestData();
    }

    submitRequest = async () => {
        const { submitRequest, modalMessage, fetchRequestLogItems } = this.props;
     
        var success = await submitRequest();

        if (success.Success) {
            fetchRequestLogItems(0);
        } else {
            var submitRequesResult = {...success, Message: this.toLocaleLanguage("modal_error_content")};
            success = submitRequesResult;
        }

        modalMessage(success);
    }

    onClickCancel = () => {
     
        const { modalClose } = this.props;


        if (modalClose) {
            modalClose();
        }
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '')
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    };

    renderPopover = (title, body) => {
        return (
            <Popover id="comp-popover" title={title} className="plan-comp-popover">
                {body}
            </Popover>
        );
    };

    render() {
        const {
            //form
            wirelessChangePricePlanFormA
            //reducer action
            , onSubscriptionSelect
            , fetchSubscriptionByValue
            , onPlanSelect
            , onOtherPlanSelect
        } = this.props;

        const { subscriptionList, takeActionCircuitCode } = this.props.createRequest;
        const { formSubmitted, planOptions, otherPlanOptions, primaryPlanDetails, vendorDetails, subscription } = this.props.wirelessChangePricePlanRequest;

        return (
            <div>
                <Form method="post" role="form"
                    model="wirelessChangePricePlanFormA"
                    onSubmit={this.submitRequest}
                >
                    <Row>
                        <Col xs={12} md={12} lg={12}>
                            <SearchSuggestions
                                value={wirelessChangePricePlanFormA.circuitCode}
                                label={`${this.toLocaleLanguage('subscription_number')} *`}
                                propDisplay={'CircuitCode'}
                                options={subscriptionList.length > 0 ? subscriptionList : ''}
                                onChangeAction={onSubscriptionSelect}
                                searchAction={fetchSubscriptionByValue}
                                defaultValue={takeActionCircuitCode}
                            />
                        </Col>
                        {wirelessChangePricePlanFormA.circuitCode != '' &&
                            <div className="pb-15-pl-30">
                                {subscription.PlanName} <span>&#8226;</span> {subscription.SimName} <span>&#8226;</span> {subscription.DeviceName != null && subscription.DeviceName != '' ? subscription.DeviceName : <Translation translationKey="no_device_available" /> }
                            </div>
                        }
                    </Row>
                    <div>
                        <h5 className="order-detail-location-title"><Translation translationKey="change_plan_to" /></h5>                       
                    <div className='new-price-plan-container'>
                        <span className='new-price-plan-title'><Translation translationKey="new_price_plan" /></span>
                        <Row>
                            <Col xs={12} md={12} lg={12}>
                                <Select
                                    className="form-control"
                                    label={`${this.toLocaleLanguage('plan')} *`}
                                    value={wirelessChangePricePlanFormA.planId}
                                    options={planOptions}
                                    placeholder={this.toLocaleLanguage('select_a_plan')}
                                    fieldProp='.planId'
                                    onChangeAction={onPlanSelect}
                                    disabled={wirelessChangePricePlanFormA.circuitId == 0}
                                />
                            </Col>
                        </Row>
                        {/* strt */}
                        <div className="price-plan-details-container">
                            <div className="price-plan-left-details">
                                <div className="price-plan-header">
                                    <span><Translation translationKey="plan_details" />*</span>
                                </div>
                                <div className="price-plan-list">
                                    {
                                        primaryPlanDetails.PlanId > 0 ?
                                            <div>
                                                <span>{primaryPlanDetails.ComponentName}</span>
                                                <br />
                                                <span><b>{primaryPlanDetails.ComponentDetails}</b></span>
                                            </div> : <span><Translation translationKey="no_selected_plan" /></span>
                                    }
                                </div>
                            </div>

                            <div className="price-plan-center-details">
                                <div className="price-plan-header">
                                    <span><Translation translationKey="other_features" /></span>
                                </div>
                                <div className="price-plant-other-features">
                                    {
                                        otherPlanOptions.length > 0 ?
                                            otherPlanOptions.map((item, i) => (
                                                <div key={i} className="ml-26">
                                                    <Control.checkbox
                                                        model={'.otherFeatures'}
                                                        //value={"test"}
                                                        className="pc-cb"
                                                        //type={'checkbox'}
                                                        //key={i}
                                                        //disabled={primaryPlanDetails.IsPrimary}
                                                        //checked={}
                                                        id={item.PlanComponentId}
                                                        defaultChecked={wirelessChangePricePlanFormA.planDetailsModel.length && wirelessChangePricePlanFormA.planDetailsModel.find(x => x.PlanComponentId === item.PlanComponentId) !== undefined}
                                                        value={item.PlanComponentId}
                                                        onChange={onOtherPlanSelect}
                                                    //id={item.PlanComponentId}
                                                    />

                                                    <OverlayTrigger placement="left" overlay={this.renderPopover('Description', item.ComponentDetails)}>
                                                        <div className="plan-comp-item">
                                                            <div className="plan-comp-name">{item.ComponentName}</div>
                                                            <div className="plan-comp-cost">
                                                                {vendorDetails.Currency} {item.ComponentCost.toFixed(2)}
                                                            </div>
                                                        </div>
                                                    </OverlayTrigger>
                                                </div>
                                            ))
                                            : ""
                                    }
                                </div>
                            </div>

                        </div>
                        {/* END */}

                        </div>
                        <div className="price-plan-total-cost-container">
                            <div className="price-plan-header">
                                <span><Translation translationKey="total_order_cost" /></span>
                            </div>
                            <div className="price-plan-total">
                                <span>{vendorDetails.Currency}</span>
                                <span>{wirelessChangePricePlanFormA.planDetailsModel.reduce((accum, item) => accum + item.ComponentCost, 0).toFixed(2)}</span>
                            </div>
                        </div>
                        <Row>
                            <Col xs={12} md={12} lg={12}>
                                <TextArea
                                    label={`${this.toLocaleLanguage('business_justification')}*`}
                                    fieldProp='.businessJustification'
                                    value={wirelessChangePricePlanFormA.businessJustification}
                                    disabled={wirelessChangePricePlanFormA.circuitId == 0}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={12} lg={12}>
                                <TextArea
                                    label={this.toLocaleLanguage('additional_information')}
                                    fieldProp='.additionalInformation'
                                    value={wirelessChangePricePlanFormA.additionalInformation}
                                    disabled={wirelessChangePricePlanFormA.circuitId == 0}
                                />
                            </Col>
                        </Row>

                    </div>
                    <div className="request-button-continer">
                        <div className="bottom-left">
                            <ORFButton
                                label={this.toLocaleLanguage('modal_close_cancel_button')}
                                variant={"light"}
                                action={this.onClickCancel}
                                type="button"
                            />
                        </div>
                        <div className="bottom-right">
                            <div>
                                <ORFButton
                                    label={this.toLocaleLanguage('submit_request_button')}
                                    variant={"primary"}
                                    type="type"
                                    disabled={wirelessChangePricePlanFormA.circuitId == 0
                                        || wirelessChangePricePlanFormA.planId == 0
                                        || wirelessChangePricePlanFormA.businessJustification == ''
                                        || wirelessChangePricePlanFormA.planDetailsModel.length == 0
                                        || formSubmitted}
                                />
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
        );
    }
};

export default connect(
    state => {
        const { wirelessChangePricePlanRequest, createRequest, translation } = state;
        const { wirelessChangePricePlanFormA } = state.form;
        return {
            wirelessChangePricePlanRequest
            , wirelessChangePricePlanFormA
            , createRequest
            , ...translation,
        };
    }
    , dispatch =>
        bindActionCreators(
            Object.assign({}, wirelessChangePricePlanActions, createRequestActions, requestLogActions),
            dispatch
        )
)(MobileChangePricePlanForm);
